(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ans-footer"]) return;
  try {
    
  (function () {
    var query = window.matchMedia('(min-width: 768px)');
    function sync() {
      document.querySelectorAll('.ans-footer__col').forEach(function (col) {
        if (query.matches) col.open = true;
      });
    }
    sync();
    query.addEventListener('change', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ans-header"]) return;
  try {
    
  // Mobile search sheet. Progressive: without JS the toggle is simply inert
  // and the form is still reachable at /search.
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.ans-header__search-toggle');
    if (!toggle) return;
    const bar = toggle.closest('.ans-header')?.querySelector('.ans-header__bar');
    if (!bar) return;
    const open = bar.classList.toggle('is-search-open');
    toggle.setAttribute('aria-expanded', String(open));
    if (open) bar.querySelector('.ans-header__search-input')?.focus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ans-header__bar.is-search-open').forEach((bar) => {
      bar.classList.remove('is-search-open');
      const toggle = bar.querySelector('.ans-header__search-toggle');
      toggle?.setAttribute('aria-expanded', 'false');
      toggle?.focus();
    });
  });

  document.addEventListener('cartLinesUpdate', (event) => {
    event.promise
      ?.then(({ cart, detail }) => {
        const itemCount = cart?.totalQuantity ?? detail?.itemCount ?? 0;
        document.querySelectorAll('.ans-header__cart-count').forEach((span) => {
          span.textContent = itemCount;
          span.style.display = itemCount > 0 ? 'inline-flex' : 'none';
        });
      })
      .catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ans-hero"] && !Shopify.designMode) return;
  try {
    
  // Hero carousel. The track scrolls and snaps on its own; this only adds
  // arrows, dots and auto-advance, which is why every control ships hidden
  // and is revealed here — no JS, no dead buttons.
  (() => {
    const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    const init = (root) => {
      if (root.dataset.ansCarousel) return;
      root.dataset.ansCarousel = 'on';

      const track = root.querySelector('.ans-carousel__track');
      const slides = Array.from(track.children);
      const dots = Array.from(root.querySelectorAll('.ans-carousel__dot'));
      const arrows = Array.from(root.querySelectorAll('.ans-carousel__arrow'));
      if (slides.length < 2) return;

      root.querySelectorAll('[hidden]').forEach((el) => el.removeAttribute('hidden'));

      // The slide on screen is the only one that animates. CSS keys off this.
      slides[0].classList.add('is-active');

      let index = 0;
      let timer = null;
      let visible = true;
      // Reassigned below once the interval exists. Any manual move — swipe,
      // arrow, dot — calls this: the visitor gets a full interval to read what
      // they just chose, the progress dot starts over instead of finishing a
      // countdown that no longer means anything, and auto-advance never ends
      // up parked because the cursor happens to be resting on the banner.
      let restart = () => {};

      const goTo = (i) => {
        index = (i + slides.length) % slides.length;
        track.scrollTo({ left: index * track.clientWidth });
      };

      // Swipe and scrollbar move the track without going through goTo, so the
      // dots read position back off scrollLeft rather than off our own state.
      let frame = 0;
      track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const next = Math.round(track.scrollLeft / track.clientWidth);
            if (next === index) return;
            index = next;
            dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
            slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
            restart();
          });
        },
        { passive: true }
      );

      arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => goTo(index + Number(arrow.dataset.step)));
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => goTo(Number(dot.dataset.index)));
      });

      const delay = Number(root.dataset.autoplay) || 0;
      if (!delay) return;

      // The dot's progress fill and the slow image push are both timed off the
      // merchant's interval, so they stay honest if it is changed in the editor.
      root.style.setProperty('--hero-autoplay', `${delay}ms`);

      const stop = () => {
        clearInterval(timer);
        timer = null;
        root.dataset.playing = 'false';
      };

      const play = () => {
        if (timer || !visible || REDUCED.matches || document.hidden) return;
        timer = setInterval(() => goTo(index + 1), delay);
        root.dataset.playing = 'true';
      };

      // Rotating away from someone who is reading, hovering, tabbing through,
      // or looking at another tab is the classic carousel failure.
      restart = () => {
        stop();
        play();
      };

      root.addEventListener('pointerenter', stop);
      root.addEventListener('pointerleave', play);
      // Only a keyboard visitor gets the focus pause. A mouse click on an arrow
      // also focuses it, and pausing on that is how the carousel ended up dead
      // after the visitor used its own controls.
      root.addEventListener('focusin', (event) => {
        if (event.target.matches(':focus-visible')) stop();
      });
      root.addEventListener('focusout', play);
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));
      REDUCED.addEventListener('change', () => (REDUCED.matches ? stop() : play()));

      new IntersectionObserver(
        ([entry]) => {
          visible = entry.isIntersecting;
          visible ? play() : stop();
        },
        { threshold: 0.25 }
      ).observe(root);
    };

    const initAll = () => document.querySelectorAll('.ans-carousel').forEach(init);

    initAll();
    // The theme editor re-renders a section in place; re-init the new node.
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ans-newsletter"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ans-newsletter-input]').forEach(function (input) {
    var form = input.closest('form');
    var error = form.querySelector('[data-ans-newsletter-error]');

    function validate() {
      if (input.value === '') {
        show('');
        return true;
      }
      if (input.validity.valid) {
        show('');
        return true;
      }
      show('Error: enter an email address, like name@example.com.');
      return false;
    }

    function show(message) {
      error.textContent = message;
      input.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    input.addEventListener('blur', validate);
    input.addEventListener('input', function () {
      if (input.getAttribute('aria-invalid') === 'true') validate();
    });

    form.addEventListener('submit', function (event) {
      if (input.value === '' || !input.validity.valid) {
        event.preventDefault();
        show('Error: enter an email address, like name@example.com.');
        input.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ans-offers-strip"] && !Shopify.designMode) return;
  try {
    
  // Offers strip: rotation and dismissal. Without JS the first message shows and
  // the dismiss button is inert — no dead states, just no rotation.
  (() => {
    const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    const init = (root) => {
      if (root.dataset.ansOffers) return;
      root.dataset.ansOffers = 'on';

      const key = root.dataset.key;
      const msgs = Array.from(root.querySelectorAll('[data-msg]'));

      root.querySelector('[data-dismiss]')?.addEventListener('click', () => {
        try {
          sessionStorage.setItem(key, '1');
        } catch (e) {
          /* Private mode. Dismissal still works, it just will not persist. */
        }
        root.remove();
      });

      const delay = Number(root.dataset.rotate) || 0;
      if (msgs.length < 2 || !delay) return;

      let index = 0;
      let timer = null;

      const show = (i) => {
        index = (i + msgs.length) % msgs.length;
        msgs.forEach((msg, n) => {
          if (n === index) msg.removeAttribute('aria-hidden');
          else msg.setAttribute('aria-hidden', 'true');
        });
      };

      const stop = () => {
        clearInterval(timer);
        timer = null;
      };

      const play = () => {
        if (timer || REDUCED.matches || document.hidden) return;
        timer = setInterval(() => show(index + 1), delay);
      };

      // §4.1: pauses on hover and on prefers-reduced-motion. Focus and tab
      // visibility are the same failure — text moving out from under someone.
      root.addEventListener('pointerenter', stop);
      root.addEventListener('pointerleave', play);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', play);
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));
      REDUCED.addEventListener('change', () => (REDUCED.matches ? stop() : play()));

      play();
    };

    const initAll = () => document.querySelectorAll('.ans-offers').forEach(init);

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
